// VITE_STAGE is injected at build-time per .env.<mode> file. The four
// values are: ide (local dev), dev, test, prod. Used by config/amplify
// and any code that branches on environment.
export const stage = import.meta.env.VITE_STAGE as 'ide' | 'dev' | 'test' | 'prod';
